import { useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { FormLabel, FormControl, Input, SimpleGrid } from 'components/UI';
import { Formik } from 'formik';
import { validateForm } from 'utils/helpers';
import { validateRequired } from 'utils/validation';
import ButtonProc, { ButtonProcProps } from 'components/common/Buttons/ButtonProc';

export interface CategoryFormValues {
  categoryName: string;
}

type AddCategoryFormProps = {
  onSubmit(values: CategoryFormValues): void;
  buttonProps?: Omit<ButtonProcProps, 'onClick'>;
};

const AddCategoryForm = ({ onSubmit, buttonProps }: AddCategoryFormProps) => {
  const [submitted, setSubmitted] = useState(false);

  return (
    <Formik
      initialValues={{ categoryName: '' }}
      validate={async (values) => {
        const errors = validateRequired<CategoryFormValues | Record<string, never>>(['categoryName'], values);

        return errors;
      }}
      onSubmit={onSubmit}
    >
      {(formConfig) => {
        const { values, handleChange, handleBlur, handleSubmit, isSubmitting } = formConfig;

        const formErrors = validateForm<CategoryFormValues>({
          ...formConfig,
          submitted,
        });

        return (
          <form onSubmit={handleSubmit}>
            <SimpleGrid columns={1} spacing={1} mb={2}>
              <Box>
                <FormLabel htmlFor="categoryName">Category</FormLabel>

                <FormControl isInvalid={!!formErrors.categoryName} mb={2}>
                  <Input
                    type="text"
                    name="categoryName"
                    maxLength={20}
                    value={values.categoryName}
                    error={formErrors.categoryName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    placeholder="Enter category name"
                  />
                </FormControl>
              </Box>
            </SimpleGrid>
            <Flex justifyContent="flex-end">
              <ButtonProc
                isDisabled={isSubmitting}
                isLoading={isSubmitting}
                onClick={() => setSubmitted(true)}
                type="submit"
                size="sm"
                first="SUBMIT"
                {...buttonProps}
              />
            </Flex>
          </form>
        );
      }}
    </Formik>
  );
};

export default AddCategoryForm;
